export const SPONSORSHIP_ATTRIBUTE = "nbcu-checkout-sponsor";
export const SPONSORSHIP_ATTRIBUTE_EPW_KEY = "usc-epw-wells-fargo-banner";
export const SPONSORSHIP_DEFAULT_SPONSOR_NAME = "Wells Fargo";
export const SPONSORSHIP_DEFAULT_TAG = "evergreen";
